export default __webpack_public_path__ + "static/unique-feature-hand-181a8fa03dc689b0b68ab56b012e2f4a.png";